// extracted by mini-css-extract-plugin
export var container = "_i1-1";
export var cornerButtonContainer = "_i1-6";
export var disabled = "_i1-2";
export var dragActive = "_i1-3";
export var fileContainer = "_i1-5";
export var hiddenInput = "_i1-4";
export var widthContainer = "_i1-0";